import React from 'react'
import { Tag, TagType } from '@islandsstofa/react'

type TagTypeThatHasTitle = Extract<
  TagType,
  'capital' | 'opportunity' | 'country' | 'date' | 'cost'
>

interface Props {
  tags: string[]
  type: TagTypeThatHasTitle
}

const TagZone = ({ tags = [], type }: Props) => {
  // Filter out empty tags and check if any are left
  if (tags.filter(t => t).length === 0) return null

  const titles: { [key in TagTypeThatHasTitle]: string } = {
    capital: 'Fjármagn',
    country: 'Lönd / Heimsálfa',
    date: 'Dagsetning',
    cost: 'Kostnaður',
    opportunity: 'Tækifæri'
  }

  return (
    <div className='mr-3 mb-3 mb-lg-0'>
      <p className='parag--sm tagzone__title mb-1'>{titles[type]}</p>
      {tags.map((tag, x) => (
        <Tag key={x} type='basic'>
          {tag}
        </Tag>
      ))}
    </div>
  )
}

export default TagZone
